import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	confirm: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	confirm: {
		id: 'issue-field-service-entity.common.collapsible-field.edit.action-buttons.confirm',
		defaultMessage: 'Confirm',
		description: 'Button to confirm any edits',
	},
	cancel: {
		id: 'issue-field-service-entity.common.collapsible-field.edit.action-buttons.cancel',
		defaultMessage: 'Cancel',
		description: 'Button to cancel any edits made ',
	},
});
export default messages;
